import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { WageType } from './wage-type.interface';

export class WageTypeService {
   async getWageTypes(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<WageType>>>(`/wage-types`, { ...cacheFirstConfig, params: { ...query } });
      return response.data;
   }
}
